module.exports = __webpack_public_path__ + "img/success.83237cbd.png";